import { useUserStore } from '../stores/user';

const useAuthUserStore = () => {
  const store = useUserStore();

  if (!store.user || !store.accessToken)
    throw new Error('User must be authenticated');

  return {
    ...store,
    user: store.user,
    accessToken: store.accessToken,
  };
};

export default useAuthUserStore;
